import { compose, withPropsOnChange } from "recompose"

import { getPlannedChecks } from "../../api/entities/plannedChecks"
import withApiTransport from "../../api/apiTransport"

const enhance = compose(
  withPropsOnChange([`sapIssueId`], ({ sapIssueId }) => ({
    load: getPlannedChecks,
    propName: `plannedChecks`,
    payload: sapIssueId,
  })),
  withApiTransport,
)

export default enhance
